/**
 * 로케일 날짜 변환
 * @param originDate - 원본 날짜
 * @returns 로케일 형식의 날짜 문자열
 * @public
 */
export const localeDate = (originDate: any) => {
  const localDate = new Date(originDate);
  return localDate.toLocaleString();
};
